import React from 'react';
import { Component, TestCase } from '../../../types';
import TestCaseLineItem from './TestCaseLineItem';

interface ComponentDetailPanelProps {
  component: Component | null;
  testCases: TestCase[];
  projectCode?: string;
  selectedTestCaseIds: Set<string>;
  onTestCaseSelect: (testCaseId: string, selected: boolean) => void;
  onTestCaseClick: (testCase: TestCase) => void;
}

const ComponentDetailPanel: React.FC<ComponentDetailPanelProps> = ({
  component,
  testCases,
  projectCode,
  selectedTestCaseIds,
  onTestCaseSelect,
  onTestCaseClick
}) => {
  if (!component) {
    return (
      <div className="library-detail-panel">
        <div className="library-detail-empty">
          <p style={{ fontSize: '2rem', marginBottom: '1rem' }}>📦</p>
          <h3>No component selected</h3>
          <p>Select a component from the sidebar</p>
        </div>
      </div>
    );
  }

  const componentTestCases = testCases.filter(tc => tc.componentId === component.id);

  return (
    <div className="library-detail-panel">
      {/* Component Header */}
      <div className="library-detail-header">
        <h2 className="library-detail-title">{component.name}</h2>
        
        <div className="library-detail-meta">
          {component.platforms && component.platforms.length > 0 && (
            <div className="library-meta-group">
              <span className="library-meta-label">Platforms:</span>
              {component.platforms.map(platform => (
                <span key={platform} className="badge badge-cyan">
                  {platform.toUpperCase()}
                </span>
              ))}
            </div>
          )}
          
          {component.milestone && (
            <div className="library-meta-group">
              <span className="library-meta-label">Milestone:</span>
              <span className="badge badge-cyan">{component.milestone}</span>
            </div>
          )}
        </div>
      </div>

      {/* Test Cases Section */}
      <div className="library-detail-body">
        <h3 className="library-detail-section-title">
          Test Cases ({componentTestCases.length})
        </h3>

        {componentTestCases.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
            <p className="text-muted">No test cases yet</p>
          </div>
        ) : (
          <div className="library-testcase-table">
            {/* Header Row */}
            <div className="library-testcase-header">
              <div />
              <div>TC-ID</div>
              <div>Title</div>
              <div>Status</div>
            </div>

            {/* Test Case Rows */}
            {componentTestCases.map(testCase => (
              <TestCaseLineItem
                key={testCase.id}
                testCase={testCase}
                projectCode={projectCode}
                isSelected={selectedTestCaseIds.has(testCase.id)}
                onSelect={onTestCaseSelect}
                onClick={onTestCaseClick}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ComponentDetailPanel;
